// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__xG+Qd","left":"Virtual_left__kswMo","wrapper":"Virtual_wrapper__xX4f5"};